import React, {useState} from 'react';
import styled from 'styled-components';
import {SortableHandle} from 'react-sortable-hoc';

import Icon from './Icon';
import Button from './Button';
import Menu from './Menu';
import { T } from '../components/I18n';

function WidgetHeader({id, preview, title, options, children}) {

  const [isMenuOpen, toggleMenu] = useState(false);

  let displayMenu = false;
  if (options && options.length > 0 && options[0] !== undefined) {
    displayMenu = true;
  }
  if (preview) {
    displayMenu = false;
  }

  return (
      <StyledWidgetHeader>
        {!preview && (
          <DragHandle>
            <Icon name="align-justify" size="1.5em" />
          </DragHandle>
        )}
        <H4><T noTranslate>{title || <span>&nbsp;</span>}</T></H4>
        {children ?
           children: null
        }
        {displayMenu && (
          <>
            <Button id={`${id}_moreMenu`} tertiary onClick={() => toggleMenu(true)}><Icon name="more-vertical" /></Button>
            <Menu open={isMenuOpen} onClose={() => toggleMenu(false)} relativeTo={`${id}_moreMenu`} position="bottom-end">
              {options.map((option, i) => {
                const {title, ...buttonProps} = option;
                  return <Menu.Option key={i} {...buttonProps}>{title}</Menu.Option>;
              })}
            </Menu>
          </>
        )}
      </StyledWidgetHeader>
  );
}

const StyledWidgetHeader = styled.div`
  padding: 1.25rem 1.875rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const H4 = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  font-weight: 500;
  flex: 1;
`;

const DragHandle = SortableHandle(styled.div`
  cursor: grab;
  color: #b4b4b4;
  margin-top: 0.4rem;
  margin-right: 1rem;
`);

export default WidgetHeader;